import { ScoutFeature } from "../../../Enums/ScoutFeature";
import { App } from "../Enums/App";

export const appFeatureLookup = new Map<App, ScoutFeature[]>()
    .set(App.Scout, [ScoutFeature.Scout4])
    .set(App.Match, [ScoutFeature.RetailMatchReports])
    .set(App.Mobilytics, [ScoutFeature.GpsInsights])
    .set(App.MyReports, [])
    .set(App.Reports, [])
    .set(App.UserSettings, [ScoutFeature.UserSettings])
    .set(App.MobilyticsPro, [ScoutFeature.MobilyticsPro])
    .set(App.Iq, [ScoutFeature.IQ])
    .set(App.Factor, [ScoutFeature.Factor])
    .set(App.Analyze, [ScoutFeature.Analyze])
    .set(App.Persona, [ScoutFeature.Persona])
;

export const isAppOutsideOfScout = (app: App): boolean => {
    return app === App.Iq || app === App.Factor || app === App.Analyze || app === App.Persona;
};
